import { FC } from "react";

import dynamic from "next/dynamic";

import { getDesignAppsDataQuery } from "lib/sanity/queries";
import { getClient } from "lib/sanity/server";

import { RankedTableDataProps } from "components/ranked-table/types";
import ExploreMoreIntegrations from "components/views/integrations/explore-integrations";
import FeatureTable from "components/views/integrations/feature-table";
import { integrationDescriptions } from "components/views/integrations/integration-descriptions";
import PartnerWithEnerflo from "components/views/integrations/partner-with-enerflo";

import Page from "../../components/layout/page";
import MainHero from "../../components/views/integrations/solar-design/main-hero";

const Features = dynamic(() => import("../../components/views/integrations/design-apps"));
const DemoFormSection = dynamic(() => import("../../components/demo-form-section"));

const SolarDesign: FC<RankedTableDataProps> = props => (
  <Page
    title="Integrations for Solar PV System Design Software"
    description="Enerflo integrates with solar PV system design software, including Aurora, Aerialytic, Everbright (Sighten), OpenSolar, Solo and more."
  >
    <MainHero />
    <FeatureTable title="Better Together: Get to Proposal Faster with Integrated Solar Design Tools">
      <Features {...props} />
    </FeatureTable>
    <ExploreMoreIntegrations
      items={[integrationDescriptions.sales, integrationDescriptions.finance, integrationDescriptions.overview]}
    />
    <PartnerWithEnerflo />
    <DemoFormSection />
  </Page>
);

export default SolarDesign;

export async function getStaticProps(ctx) {
  const { preview = null } = ctx;

  const client = getClient(preview);
  let designAppsData: RankedTableDataProps = {
    integratorsList: [],
    features: [],
  };

  try {
    designAppsData = await client.fetch(getDesignAppsDataQuery(preview));
  } catch (e) {
    console.error("Unable to fetch design apps data", e);
  }

  return {
    props: {
      preview,
      ...designAppsData,
    },
  };
}
